import React from 'react'

const ScoreHigh = ({height=30, width=30, color='white'}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
            <path d="M6.52308 14.7969C5.58558 15.3594 4.46058 14.9844 3.89808 14.0469C3.33558 13.1094 3.71058 12.1719 4.64808 11.6094L14.0231 5.98438C14.5856 5.60938 15.3356 5.60938 15.8981 5.98438L25.2731 11.6094C26.2106 12.1719 26.3981 13.2969 25.8356 14.2344C25.4606 14.9844 24.3356 15.3594 23.3981 14.7969L14.9606 9.73438L6.52308 14.7969Z" fill={color} />
            <path d="M6.52308 22.8711C5.58558 23.4336 4.46058 23.2461 3.89808 22.3086C3.33558 21.3711 3.71058 20.2461 4.64808 19.6836L14.0231 14.0586C14.5856 13.6836 15.3356 13.6836 15.8981 14.0586L25.2731 19.6836C26.2106 20.2461 26.3981 21.3711 25.8356 22.3086C25.2731 23.2461 24.1481 23.4336 23.2106 22.8711L14.9606 17.8086L6.52308 22.8711Z" fill={color} />
        </svg>
    )
}

export default ScoreHigh